module.exports = __webpack_public_path__ + "img/sub1.9702b698.jpg";